/**
 * 根据list的field配置输出快速查询，高级查询 ，单独放出条件的查询
 * 快速查询的输出有两种方式：1.把查询条件合并放入到一个下拉选择项中去输出 2.以动态字段的方式去输出
 * 快速查询-合并到下拉选择项中输出 结构：[{id:"filtermode",type:"select",subdata:[]}] 通过changehandler隐藏显示字段的方式
 * 快速查询-动态字段输出 [{id:"",dynamicConfig:"[]"}] 把字段放到组件的动态执行change的时候重新初始化表单
 */
import { fieldSortFunc } from './field-sort';//排序
import $ from 'jquery';
declare const window:any;
export const queryListFieldFunc:Function = function(fieldArray:any,options:any){
    let resultObject:any = {
        querForm:[],//快速查询
        advanceForm:[],//高级查询
        advanceValue:{},//高级查询默认输出值
        form:[],//展开多个输出
        quicklyQueryColumnNames:[],//快速查询的字段
        dynamicFieldsJson:{},//动态字段的形式输出
        type:"select",//默认输出形式是下拉
        id:options.id,
        queryId:'query-'+options.id,
        advanceId:'advance-query-'+options.id,
    };
    options = typeof(options)=='object' ? options : {};
    let isUseSelectQuickSearch:boolean = typeof(options.isUseSelectQuickSearch)=='boolean' ? options.isUseSelectQuickSearch : true;//是否使用快速查询
    let quickQueryGroupNumber:number = options.quickQueryGroupNumber;//默认输出1个
    let sortField:string = options.sortField ? options.sortField : 'queryOrder';//排序字段
    let businessTempaltePageParam:any = typeof(options.businessTempaltePageParam)=='object' ? options.businessTempaltePageParam : {};
    let quickQuerySubdataField = [];//快速查询subdata的形式存储输出
    let quickQuerySubdataDynamicField = [];//快速查询subdata动态字段的形式存储输出
    if(quickQueryGroupNumber > 1){
        isUseSelectQuickSearch = false;   //查询条件输出两个以上的时候禁止输出快速查询
    }
    let newFieldArray:any = window.NSUtils.deepCopy(fieldArray);//先克隆保留原始入参不变
    fieldSortFunc(newFieldArray,sortField);//按照数值类型进行字段升序排序
    for(let fieldI=0; fieldI<newFieldArray.length; fieldI++){
        let fieldData:any = newFieldArray[fieldI];
        let searchable:boolean = typeof(fieldData.searchable) == 'boolean' ? fieldData.searchable : false;//是否配置了支持搜索
        let isQuickQuery:boolean = typeof(fieldData.isQuickQuery) == 'boolean' ? fieldData.isQuickQuery : false;//是否支持快速查询
        let editConfig:any = typeof(fieldData.editConfig)=='object' ? fieldData.editConfig : {};
        let businessConfig:any = typeof(fieldData.businessConfig)=='object' ? fieldData.businessConfig : {};
        let idStr:string = fieldData.field;//id字段
        let textStr:string = fieldData.title ? fieldData.title : idStr;//如果没有定义标题输出则读取field
        let componentType:string = editConfig.type ? editConfig.type : 'text';//默认按文本
        let quickQueryComponentType:string = editConfig.type ? editConfig.type : 'text';//快速查询输出的字段类型
        let isAloneQuery:boolean = typeof(editConfig.isAloneQuery) == 'boolean' ? editConfig.isAloneQuery : false;
        if(fieldData.isTreeNode === true){
            textStr = fieldData.chineseName;//读取默认字段的配置
        }
        if(isQuickQuery === true){
            resultObject.quicklyQueryColumnNames.push(idStr);//快速查询的字段
        }
        if(searchable === true){
            //支持查询
            /***********快速查询 start**************** */
            let dynamicConfig = window.NSUtils.deepCopy(editConfig);
            switch(componentType){
                case 'textarea':
                case 'text':
                    if(editConfig.isUseTextRange === true) {
                        quickQueryComponentType = 'textRange';
                    }
                    break;
                case 'business':
                case 'businessSelect':
                    dynamicConfig = businessConfig;
                    dynamicConfig.isNeedJumpNext = false;
                    break;
                case 'radio':
                    quickQueryComponentType = 'select';//快速查询如果输出radio和checkbox输出字段太长，所以转换成下拉去输出
                    break;
                case 'checkbox':
                    quickQueryComponentType = 'select';//快速查询如果输出radio和checkbox输出字段太长，所以转换成下拉去输出
                    dynamicConfig.selectMode = 'multi';//多选输出
                    break;
                case 'number':
                    quickQueryComponentType = 'numberRange';//快速查询-输出数字区间
                    break;
                case 'date':
                    if(editConfig.isSaveDateRange === false){
                        quickQueryComponentType = 'dateRangePicker';
                        dynamicConfig.isRelativeTime = true;
                    }
                    break;
                default:
                    break;
            }
            dynamicConfig.type = quickQueryComponentType;
            let quickQueryJson:any = {
                value:idStr,
                text:'按'+textStr+'查询',
                searchType:quickQueryComponentType,//默认按文本
            };//快速查询 查询条件：按+字段+查询 (生成检索条件的subdata)
            let dynamicQueryJson:any = {
                value:idStr,
                text:'按'+textStr+'查询',
                searchType:quickQueryComponentType,//默认按文本
            };
            /***********快速查询 end**************** */
            /***********高级查询 start**************** */
            /***********高级查询 end**************** */
            if(isAloneQuery === false){
                quickQuerySubdataField.push(quickQueryJson);//不是单独作为查询条件放出的即快速查询
            }
        }
    }
    console.log(quickQuerySubdataField)
    if(quickQueryGroupNumber > resultObject.querForm.length){
        //实际输出的查询条件小于当前设定的值
        options.quickQueryGroupNumber = resultObject.querForm.length;
    }
    if(options.quickQueryGroupNumber === 1 && options.isUseSelectQuickSearch === true){
        isUseSelectQuickSearch = true;
    }
    if(isUseSelectQuickSearch === true){
        resultObject.querForm.unshift({
            text:'快速查询',
            value:'quickSearch',
            searchType:'text',
        });
    }
    return resultObject;
}